import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const CreateBoardModal = ({ show, handleClose, onCreateBoard }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    const handleSubmit = () => {
        const boardData = {
            name,
            description
        };
        onCreateBoard(boardData);
        setName('');
        setDescription('');
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Create New Board</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Board Name *</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="e.g., Work Projects, Personal Tasks, Side Projects"
                        />
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Brief description of this board's purpose"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                <Button variant="primary" onClick={handleSubmit} disabled={!name.trim()}>
                    Create Board
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateBoardModal;
